const MessageSubTypes = {
  SMS_OPT_IN_NOTIFICATION: 'SMS_OPT_IN_NOTIFICATION',
  SMS_OPT_OUT_NOTIFICATION: 'SMS_OPT_OUT_NOTIFICATION',
  USER_AWAY_NOTIFICATION: 'USER_AWAY_NOTIFICATION',
  CHATBOT_MESSAGE: 'CHATBOT_MESSAGE',
  VWR_CALL: 'VIRTUAL_WAITING_ROOM_CALL_INVITE',
};

export default MessageSubTypes;
